<template>
  <div
    class="kye-guide-container"
    :class="version ? uniqueClass : ''"
    v-if="visible"
  >
    <div class="kye-guide-helper-class" :style="{...helperStyle, ...customHelperStyle}"></div>
    <div
      class="kye-guide-popper"
      :class="version ? guidePopper : ''"
      :style="style"
      ref="guideContent"
    >
      <div>
        <div v-if="visibleCloseBtn || item.title" class="guide-header" :class="item.title?'flex-sb' : 'flex-end'">
          <div v-if="item.title" class="guide-header-label" :style="{...customTitleStyle}">{{item.title}}</div>
          <div v-if="visibleCloseBtn" class="guide-header-close">
            <i
              class="el-icon-close icon-close-style"
              @click="close"
            ></i>
          </div>
        </div>
        <node v-if="item.message" :value='item.message' :type='item.messageType'></node>
      </div>
      <div v-if="visibleFooter" class="guide-footer" :class="steps.length !== 1?'flex-sb' : 'flex-end'">
        <el-button v-if="steps.length !== 1" :disabled='stepNumber === 0' @click="preClick">{{preButtonText}}</el-button>
        <el-button  @click="closeBtn ? close() : nextClick()">{{ closeBtn ? closeBtnText : nexButtonText}}</el-button>
      </div>
      <node
        v-if="closeFormatter"
        :value="closeFormatter"
      ></node>
    </div>
  </div>
</template>

<script>
/*
  popper 放置位置，可接受如下值：
    top(-start, -end)
    right(-start, -end)
    bottom(-start, -right)
    left(-start, -end)
  version: 'KYE_GUIDE_VERSION+年月日时分'

  如果是弹窗 首先查看父级是否有定位，没有则添加相对定位，
  同时遮罩为绝对定位设置为 top.left为0
*/
import node from './steps-item.js'
import { KYE_GUIDE_VERSION } from './kye-guide.js'
import { isDOM, scrollParentToElement, setShowElement, setElementHidden, setElementPosition, getScrollParent } from './utils'
import Popper from 'element-ui/src/utils/popper.js'
export default {
  name: 'guide',
  components: {
    node
  },
  data () {
    return {
      style: {
        backgroundColor: '#fff'
      },
      version: '',
      visibleFooter: true,
      visibleArrow: true,
      steps: [],
      preButtonText: '上一步',
      nexButtonText: '下一步',
      closeBtnText: '关闭',
      stepNumber: 0,
      visible: false,
      popperJS: null,
      closeFormatter: null,
      boundariesElement: null,
      overlayClassName: 'kye-guide-overlay',
      id: '',
      helperStyle: {},
      visibleCloseBtn: true,
      customHelperStyle: {},
      customTitleStyle: {},
      arrowClass: ''
    }
  },
  computed: {
    item() {
      return this.steps[this.stepNumber] || ''
    },
    closeBtn() {
      return this.stepNumber === this.steps.length - 1
    },
    uniqueClass() {
      return KYE_GUIDE_VERSION + this.version
    },
    guidePopper() {
      return 'kye-guide-popper-' + this.version
    },
  },
  methods: {
    // 删除遮罩层和组件节点，在关闭的时候
    removeDom() {
      const overlayDom = document.querySelector('.' + this.overlayClassName)
      if (this.parent) {
        overlayDom && this.parent.removeChild(overlayDom)
        this.parent.removeChild(this.$el)
      }
    },
    close() {
      this.visible = false
      // 存入本地
      this.removeDom()
      // 销毁Popper
      this.doDestroy()
      // 存入本地内存，版本号
      if (!this.id) {
        this.id = this.$store.state.user.id + '_'
      }
      const key = KYE_GUIDE_VERSION + this.id + this.version
      localStorage.setItem(key, this.version)
      // 去除当前弹窗的样式
      const { element } = this.item
      setElementHidden(element)
      if (this.onAfterexit && typeof this.onAfterexit === 'function') {
        this.onAfterexit.bind(this)()
      }
      // 如果不是dom就是选择器
      const elementType = typeof element
      const dom = isDOM(element) ? element : (element && element.$el ? element.$el : (elementType === 'string' ? document.querySelector(element) : ''))
      if (!isDOM(dom) || !dom) {
        return
      }
      const parent = getScrollParent(dom)
      // 重置滚动条高度
      if (parent && parent.scrollTop) {
        parent.scrollTop = 0
      }
    },
    handleCloseFormatter() {
      this.$emit('closeInstance', this)
    },
    preClick() {
      this.hiddenElement(this.stepNumber)
      this.stepNumber--
    },
    hiddenElement(i) {
      const { element, doneCb } = this.steps[i]
      setElementHidden(element)
      doneCb && typeof doneCb === 'function' && doneCb.bind(this)()
    },
    nextClick() {
      if (this.closeBtn) {
        return
      }
      this.hiddenElement(this.stepNumber)
      this.stepNumber++
    },
    computedElementStyle() {
      this.$nextTick(() => {
        if (typeof this.item === 'string') {
          return
        }
        const { element, placement } = this.item
        // 如果不是dom就是选择器
        const elementType = typeof element
        const dom = isDOM(element) ? element : (element && element.$el ? element.$el : (elementType === 'string' ? document.querySelector(element) : ''))
        if (!isDOM(dom) || !dom) {
          return
        }

        // 滚动到dom
        scrollParentToElement(dom)
        setElementPosition(this.parent)
        // 气泡定位
        this.$nextTick(() => {
          // helper样式，根据边界的dom和 当前dom计算定位
          const { width, height, top, left } = dom.getBoundingClientRect()
          const { top: pT, left: pl } = this.parent.getBoundingClientRect()
          this.helperStyle = {
            width: width + 10 + 'px',
            height: height + 10 + 'px',
            top: top - pT - 5 + 'px',
            left: left - pl - 5 + 'px',
          }
          this.createPopper(dom, placement)
        })
      })
    },
    createPopper(dom, placement = 'bottom') {
      if (!this.boundariesElement) {
        this.boundariesElement = document.querySelector('.main-panel') || document.body
      }
      // 添加箭头
      const popper = document.querySelector('.' + this.guidePopper)
      if (!popper) {
        return
      }
      this.visible && this.visibleArrow && this.appendArrow(popper)
      // 高亮显示提示的dom
      this.visible && setShowElement(dom)
      // 先销毁。再创建
      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy()
      }
      this.popperJS = new Popper(dom, popper, {
        placement, // 初始的气泡位置
        arrowOffset: 0, // 箭头的偏移
        boundariesElement: this.boundariesElement // 边界的位置 指定为main.js 可选
      })
      this.popperJS.onCreate(_ => {
        // 更新位置
        this.$nextTick(this.updatePopper)
      })
    },
    updatePopper() {
      const popperJS = this.popperJS
      if (popperJS) {
        // 调用Popper实例内部更新函数更新状态，包括left，top的位置
        popperJS.update()
      // this.popperJS为空时，Popper还没被创建，故调用createPopper函数
      } else {
        this.createPopper()
      }
    },
    // 销毁popper
    doDestroy() {
      this.popperJS.destroy()
      this.popperJS = null
    },
    // 添加箭头
    appendArrow(element) {
      let hash
      // 添加了就不添加了
      if (this.appended) {
        return
      }
      this.appended = true
      for (let item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name
          break
        }
      }
      const arrow = document.createElement('div')
      if (hash) {
        arrow.setAttribute(hash, '')
      }
      arrow.setAttribute('x-arrow', '')
      arrow.className = 'popper__arrow ' + this.arrowClass
      element.appendChild(arrow)
    },
  },
  mounted() {
    this.$bus.$on('TAB_CLICK', (e) => {
      this.computedElementStyle()
    })
  },
  watch: {
    item() {
      this.computedElementStyle()
    }
  }
}
</script>

<style lang="less">
@import url('./arrow.css');
.kye-guide-container {
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-sb {
    justify-content: space-between;
  }
  .flex-end {
    justify-content: flex-end;
  }
  .guide-message-box {
    box-sizing: content-box;
    position: absolute;
    z-index: 99999;
    background-color: transparent;
    transition: all .3s ease-out;

  }
  .icon-close-style {
    font-size: 16px;
    cursor: pointer;
  }
  .guide-footer {
    .flex;
    padding: 10px;
    border-top: 1px solid #e0e0e0;
  }
  .guide-header {
    .flex;
    .guide-header-label {
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
    }
    .guide-header-close {
      padding: 7px;
    }
  }
  .kye-guide-popper {
    padding: 10px;
    min-width: 300px;
    border-radius: 5px;
    z-index: 100000;
    color: #333;
  }
}
.kye-guide-overlay {
  position: fixed;
  top: 78px;
  // // top: 50px;
  left: var(--menu-width);
  bottom: 0;
  right: 0;
  // opacity: 0.5;
  // background: #000;
  z-index: 998;
  // width: 100%;
}
.kye-guide-overlay-absolute {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  // opacity: 0.5;
  // background: #000;
  z-index: 998;
  // width: 100%;
}
.guide-relativePosition {
  position: relative;
}
.guide-showElement {
  z-index: 999!important;
  pointer-events: none; // 禁止点击事件
}
.kye-guide-helper-class {
  position: absolute;
  box-shadow: transparent 0px 0px 1px 20px, rgba(0, 0, 0, .5) 0px 0px 0px 5000px;
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-guide/kye-guide.vue